import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Typography,
} from 'antd';

import { Filters } from '../../../containers/Filters';
import { Spinner } from '../../UI';

import styles from './Quality.module.css';

const { Title } = Typography;

class Quality extends Component {
  state = {
    aff: '',
  };

  handleSelect = (value) => {
    this.setState({
      aff: value
    });

    this.loadIframe(value);
  };

  loadIframe = (aff) => {
    if (!aff) {
      return;
    }

    document.getElementById('frame').innerHTML = '';
    const wdURL = 'https://members.whitediagnostic.com/index.php?act=dashboard&tockenI=akjsbcjasbcjsbcjhbsacbsyubuysbcj&_wd_t=' + aff;
    const iframe = document.createElement("iframe");
    iframe.setAttribute("src", wdURL);
    iframe.style.width = "100%";
    iframe.style.height = "100%";
    iframe.style.border = "none";
    iframe.class = "wdIframe";
    document.getElementById('frame').appendChild(iframe);
  };

  componentDidMount () {
    this.props.fetchUserInfo(() => {
      const slicedAffList = [...this.props.affList.slice(1)];

      if (slicedAffList.length > 0) {
        this.loadIframe(slicedAffList[0].aff);
      }
    });
  };

  render() {
    const { pageLoading } = this.props;

    let content = <Spinner/>;
    if (!pageLoading) {
      content = (
        <>
          <Filters
            handleSelect={this.handleSelect}
            subs={false}
            qualityList
          />
          <div
            style={{ height: '100%' }}
            id="frame"
            className={styles.iframe}
          />
        </>
      );
    }

    return (
      <div style={{ height: 'calc(100vh - 320px)' }}>
        <Title>Quality</Title>
        {content}
      </div>
    );
  }
}

Quality.propTypes = {
  pageLoading: PropTypes.bool.isRequired,
  user: PropTypes.object.isRequired,
  fetchUserInfo: PropTypes.func.isRequired,
};

export default Quality;
